<template>
  <div>
    <MsButton :button-font="buttonFontStyle" :button-custom-style="buttonClassStyle">
      {{ name }}
    </MsButton>
  </div>
</template>

<script setup lang="ts">
import { defineProps, watch, computed } from 'vue'
import { useDateTimeStore } from '@/stores/DateTimeFilterStore'
import MsButton from '@/components/general/buttons/MsButton.vue'

const props = defineProps({
  isActive: Boolean,
  lastXhours: {
    type: Number,
    default: 24
  },
  name: {
    type: String,
    default: 'Last 24 h'
  }
})

const { setDateTime } = useDateTimeStore()

watch(
  () => props.isActive,
  (newVal) => {
    if (newVal) {
      const dateTime = new Date()
      dateTime.setHours(dateTime.getHours() - props.lastXhours)

      setDateTime(dateTime)
    }
  }
)
const buttonFontStyle = computed(() => `${props.isActive ? 'NKT-P2-medium' : 'NKT-P2'}`)

const buttonClassStyle = computed(() => `btn-filter ${props.isActive ? 'active' : ''}`)
</script>
